
export interface PersonalDetails {
    contactNumber: string;
    dateOfBirth: string;
    emailAddress: string;
    forename: string;
    gender: string;
    maritalStatus: string;
    postcode: string;
    surname: string;
    ukaddressIndicator: string;
    consentDate: string;
    consentIndicator: string;
    pwAppointmentdate: string;
    customerCareInfo?: string;
    internalSoftOptInInd?: string;  
    mobilePhone?:number;
    homePhone?:number;  
}
